import { render, staticRenderFns } from "./DashboardAdvice.vue?vue&type=template&id=7e92f2ec&scoped=true&"
import script from "./DashboardAdvice.vue?vue&type=script&lang=js&"
export * from "./DashboardAdvice.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdvice.vue?vue&type=style&index=0&id=7e92f2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e92f2ec",
  null
  
)

/* custom blocks */
import block0 from "./DashboardAdvice.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./DashboardAdvice.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCard,VCarousel})
